import { Measure, isExpectedLabelMeasureCode } from 'services/model/model.service';

export function measureHasExpectedLabel(measure: Measure): boolean {
  return isExpectedLabelMeasureCode(measure.code);
}
